export interface StrapiBlockNode {
    type: string;
    text: string;
    children: StrapiBlockNode[];
}

export interface ReactBlockNode {
    props: {
        text?: string;
        content?: {
            children: {
                text: string;
            }[];
        };
    };
}

export const extractTextFromStrapiBlockNode = (
    children: StrapiBlockNode[]
): string => {
    return children.reduce((acc, child) => {
        if (
            child.children &&
            Array.isArray(child.children) &&
            child.children.length > 0
        ) {
            return acc + extractTextFromStrapiBlockNode(child.children);
        }
        if (child.type === "text") {
            return acc + child.text;
        }
        return acc;
    }, "");
};

export const extractTextFromReactBlockNode = (
    children: ReactBlockNode[]
): string => {
    return children.reduce((acc, child: ReactBlockNode) => {
        if (
            child?.props?.content?.children &&
            Array.isArray(child.props?.content?.children) &&
            child.props?.content?.children.length > 0
        ) {
            return (
                acc +
                child.props?.content?.children
                    .map(({ text }) => text || "")
                    .join("")
            );
        }
        if (child.props.text) {
            return acc + child.props.text;
        }
        return acc;
    }, "");
};
